import React from 'react'
import LessonOrders from './lesson_orders/index'

class LessonPlanPricing extends React.Component {

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.lesson_plan !== this.props.lesson_plan)
      return true

    if (nextProps.enquiry_id !== this.props.enquiry_id)
      return true

    if (nextProps.pricing_calculator !== this.props.pricing_calculator)
      return true

    return false
  }

  render() {
    return (
      <LessonOrders
        lesson_plan={this.props.lesson_plan}
        pricing_calculator={this.props.pricing_calculator}
        change_applied={this.props.change_applied}
      />
    )
  }
}

export default LessonPlanPricing
